import { useEffect } from "react";
import { obterPesquisa } from "../../utils/contextoPesquisa";

const Home = () => {
  useEffect(() => {
    //Limpar dados de pesquisa antigos
    obterPesquisa('');
  }, []);

  return (
    <div
      style={{
        paddingTop: "8rem",
        color: "#205bb9",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <p style={{ fontWeight: "bold", fontSize: 29.036, margin: 0 }}>
          Seja Bem Vindo (a)!
        </p>
        <p style={{ fontWeight: "bold", fontSize: 80, margin: 0 }}>CAND PREVIC</p>
        <p style={{ fontWeight: "bold", fontSize: 24.192 }}>
          Cadastro Nacional de Dirigentes
        </p>
      </div>
    </div>
  );
};

export default Home;
